module.exports = __webpack_public_path__ + "static/img/skala-logo-sem-bg.5e2dc44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skala-logo-sem-bg.png
// module id = o7pd
// module chunks = 1